import { FuseNavigationItem } from '@fuse/components/navigation';
import { amaNavigation } from './apps/ama/ama.navigation';
import { chatNavigation } from './apps/chat/chat.navigation';

export const adminNavigation: FuseNavigationItem[] = [
    amaNavigation,
    //chatNavigation
];
